import { createContext } from 'react';

import type { ApiClient } from './ApiClient';

const ApiClientContext = createContext<ApiClient | null>(null);

ApiClientContext.displayName = 'ApiClientContext';
export default ApiClientContext;
export { ApiClientContext };
